import { styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import { makeStyles } from "@mui/styles";

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "10px 18px 10px 14px",
  margin: "0 8px",
  borderRadius: "4px",
  textDecoration: "none",
  color: 'white',
  opacity: 0.8,
  "&.active": {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    opacity: 1,
    fontWeight: 500,
  },
  "&:hover": {
    opacity: 0.8,
    fontWeight: 500,
  },
}));


export const useStyles = makeStyles({
  listItems:{
    "& .css-10hburv-MuiTypography-root":{
      fontSize:'1rem'
    }
  }
})